export default `<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 18 18"
  height="18"
  width="18"
>
  <path
    d="m 0.01351943,8.9836828 3.22924197,-3.21295 5.7572232,5.7409002 5.7572244,-5.7409002 3.22926,3.21295 -9.0027874,9.0027902 z"
  />
</svg>`;
